function sortByWaitTime (a, b) {
  return a.wait_time.localeCompare(b.wait_time)
}

function sortByDuration (a, b) {
  return a.duration.localeCompare(b.duration)
}

export { sortByWaitTime, sortByDuration }
